module.exports = __webpack_public_path__ + "img/dovf_eosvaultfort.2c36b94.png";